import { baseSplitApi } from "../../baseApi"


const onBoardingCandidatePath = "/recruitment/onboarding_candidate"
const emailIdPath = '/recruitment/onboarding_candidate?emailKey=""'
const sendRecruitmentDataPath = '/recruitment/onboarding_candidate/bulk'

export const onboardedCandidatesTableTag = "ONBOARDED_CANDIDATES_TABLE"
const onboardedCandidateApprovalTag = "ONBOARDED_CANDIDATE_APPROVAL"
export const onboardingCandidatesApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        onboardedCandidates: build.query({
            query: () => {
                return {
                    url: `${onBoardingCandidatePath}`,
                    method: 'GET'
                }
            },
            providesTags: [onboardedCandidatesTableTag, onboardedCandidateApprovalTag]

        }),
        singleCandidateInfo: build.query({
            query: (_id) => {
                return {
                    url: `${onBoardingCandidatePath}/${_id}`,
                    method: 'GET'
                }
            },
            providesTags: [onboardedCandidateApprovalTag]

        }),

        updateSingleCandidateApprovalStage: build.mutation({
            query: ({ stage, employeeId }) => {

                return {
                    url: `${onBoardingCandidatePath}/${stage}/${employeeId}`,
                    method: 'PUT'
                }
            },
            invalidatesTags: [onboardedCandidateApprovalTag]
        }),
        addSingleCandidate: build.mutation({
            query: (details) => {
                return {
                    url: onBoardingCandidatePath,
                    method: 'POST',
                    body: details
                }
            },
            invalidatesTags: [onboardedCandidatesTableTag]

        }),
        updateSingleCandidate: build.mutation({
            query: (details) => {
                return {
                    url: onBoardingCandidatePath,
                    method: 'PUT',
                    body: details
                }
            },

        }),

        //commented for future use

        // getEmailId: build.mutation({
        //     query: () => {
        //         return {
        //             url: emailIdPath,
        //             method: "GET"
        //         }
        //     },
        //     providesTags: [sendRecruitmentDataPath]
        // }),
        // sendBulkCandidateDate: build.mutation({
        //     query: (recruitmentData) => {
        //         return {
        //             url: sendRecruitmentDataPath,
        //             method: "POST",
        //             body: recruitmentData
        //         }
        //     }
        //     , invalidatesTags: [emailIdPath],
        // }),

    }),
    overrideExisting: false,
})

export const { useSingleCandidateInfoQuery, useUpdateSingleCandidateApprovalStageMutation, useOnboardedCandidatesQuery, useAddSingleCandidateMutation, useUpdateSingleCandidateMutation } = onboardingCandidatesApi